import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AllArticlesComponent } from './all-articles/all-articles.component';

import { ArticleComponent } from './article/article.component';
import { ArticlesComponent } from './articles/articles.component';

const routes: Routes = [
    { path: '', component: ArticlesComponent },
    { path: 'all', component: AllArticlesComponent },
    { path: ':franchiseId', component: ArticlesComponent },
    { path: 'franchise/:franchiseId', component: ArticlesComponent },
    { path: ':franchise_id/:id', component: ArticleComponent },
    { path: ':franchise_id/:year/:month/:day/:id', component: ArticleComponent },
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);
